var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82667 5.5L8.596 11.5M5.404 11.5L5.17333 5.5M11.8187 3.36C12.0467 3.39466 12.2733 3.43133 12.5 3.47066M11.8187 3.36L11.1067 12.6153C11.0776 12.9921 10.9074 13.3441 10.63 13.6008C10.3527 13.8575 9.9886 14.0001 9.61067 14H4.38933C4.0114 14.0001 3.64735 13.8575 3.36999 13.6008C3.09262 13.3441 2.92239 12.9921 2.89333 12.6153L2.18133 3.36M11.8187 3.36C11.0492 3.24367 10.2758 3.15539 9.5 3.09533M2.18133 3.36C1.95333 3.394 1.72667 3.43066 1.5 3.47M2.18133 3.36C2.95076 3.24368 3.72416 3.1554 4.5 3.09533M9.5 3.09533V2.48466C9.5 1.698 8.89333 1.042 8.10667 1.01733C7.36908 0.993755 6.63092 0.993755 5.89333 1.01733C5.10667 1.042 4.5 1.69866 4.5 2.48466V3.09533M9.5 3.09533C7.83581 2.96672 6.16419 2.96672 4.5 3.09533",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d2776f6d9c56cc802bf88d67522c45d2.svg";
export { ForwardRef as ReactComponent };